import type {
  FilterItemsEmailChangeRequest,
  FilterItemsEmailT,
  FilterItemsTextChangeRequest,
  FilterItemsTextT,
  ReanalyzeStatusT,
  TemplateDetectionT,
} from '@/types/filterItems';
import { getCurrWorkspaceAlias } from '@/utils/workspace';

import { defaultAxios } from '..';

const filterItemsService = {
  async fetchAnalysisFilterTexts() {
    try {
      const res = await defaultAxios.get<FilterItemsTextT>(
        `/workspaces/${getCurrWorkspaceAlias()}/filter_items/analysis/texts`,
      );
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  async fetchAnalysisFilterEmails() {
    try {
      const res = await defaultAxios.get<FilterItemsEmailT>(
        `/workspaces/${getCurrWorkspaceAlias()}/filter_items/analysis/emails`,
      );
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  async fetchAnalysisReanalyzeStatus() {
    try {
      const res = await defaultAxios.get<ReanalyzeStatusT>(
        `/workspaces/${getCurrWorkspaceAlias()}/filter_items/analysis/reanalyze`,
      );
      return res.data.reanalyze_status;
    } catch (e) {
      console.error(e);
    }
  },

  async fetchAnalysisTextsTemplateDetection() {
    try {
      const res = await defaultAxios.get<TemplateDetectionT>(
        `/workspaces/${getCurrWorkspaceAlias()}/filter_items/analysis/template_detection`,
      );
      return res.data;
    } catch (e) {
      console.error(e);
    }
  },

  async triggerAnalysisFilterTextsTemplateDetection(): Promise<void> {
    try {
      const res = await defaultAxios.post(
        `/workspaces/${getCurrWorkspaceAlias()}/filter_items/analysis/template_detection`,
      );
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  async resetTemplateDetection(): Promise<void> {
    try {
      const res = await defaultAxios.patch(
        `/workspaces/${getCurrWorkspaceAlias()}/filter_items/analysis/template_detection/reset`,
      );
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  async changeAnalysisFilterTexts(data: FilterItemsTextChangeRequest) {
    try {
      const res = await defaultAxios.patch<FilterItemsTextT>(
        `/workspaces/${getCurrWorkspaceAlias()}/filter_items/analysis/texts`,
        data,
      );

      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  async changeAnalysisFilterEmails(data: FilterItemsEmailChangeRequest) {
    try {
      const res = await defaultAxios.patch<FilterItemsEmailT>(
        `/workspaces/${getCurrWorkspaceAlias()}/filter_items/analysis/emails`,
        data,
      );
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  async fetchImportFilterEmails() {
    try {
      const res = await defaultAxios.get<FilterItemsEmailT>(
        `/workspaces/${getCurrWorkspaceAlias()}/filter_items/import/emails`,
      );
      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },

  async changeImportingFilterEmails(
    data: FilterItemsEmailChangeRequest,
  ): Promise<FilterItemsEmailT> {
    try {
      const res = await defaultAxios.patch(
        `/workspaces/${getCurrWorkspaceAlias()}/filter_items/import/emails`,
        data,
      );

      return res.data;
    } catch (e) {
      console.error(e);
      throw e;
    }
  },
};

export default filterItemsService;
